import { call } from 'redux-saga/effects';
import { COUNTRY_CODE_TO_NAME } from 'constants/countries-served';
import { selectCountry } from 'redux/modules/locale';

export function* termsOnEnter(store, { location }, replaceState) {
  if (location.pathname.match(/terms\/?$/)) {
    const countryCode = selectCountry(store.getState());
    // Only redirect if it's for an active country code
    if (countryCode in COUNTRY_CODE_TO_NAME) {
      return yield call(replaceState, `/terms/${countryCode.toLowerCase()}`);
    }
  }
}
